import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@services/authentication.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class VendorFormGuard {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        @Inject(PLATFORM_ID) private platformId: any
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            return true;
        } else if (isPlatformBrowser(this.platformId)) {
            return this.authenticationService.getUserDetails().pipe(map((user: any): any => {
                if (!_.isEmpty(user.data)) {
                    return true;
                }
                // Redirect to register page instead of login
                this.router.navigate(['/register'], { queryParams: { returnUrl: state.url } });
                return false;
            }))
        } else {
            return false;
        }
    }
}
